import {
  AppDefinedVariables,
  HyperlinkVariable,
  NumStringVariable,
} from "../textInterfaces";

export const getValue = <
  VariableValues extends NumStringVariable | HyperlinkVariable,
  VariableKeys extends keyof VariableValues,
>(
  variableName: string,
  variableValues: string | number | VariableValues,
  property: VariableKeys,
  appDefinedVariables?: AppDefinedVariables,
): string => {
  if (property === "example") {
    throw new Error(
      "You can't use the example property of a variable. Use fallback or define it in appDefinedVariables in stead",
    );
  }

  if (
    appDefinedVariables !== undefined &&
    appDefinedVariables.hasOwnProperty(variableName)
  ) {
    const variable = appDefinedVariables[variableName];

    if (typeof variable === "object") {
      const value = variable.hasOwnProperty(property)
        ? variable[property as keyof typeof variable]
        : variable;

      return `${value}`;
    } else {
      return `${variable}`;
    }
  }

  if (
    typeof variableValues === "string" ||
    typeof variableValues === "number"
  ) {
    return `${variableValues}`;
  }

  if (variableValues[property] === undefined) {
    throw new Error(
      `The variable [${variableName}] does not have a fallback property. You have to define its value in the appDefinedVariables`,
    );
  }
  return `${variableValues[property]}`;
};
